export class StorePhysicianDataAction {
  static readonly type = '[Physicians] Physicians';

  constructor(public payload: any[]) {}
}

export class StoreStaffDataAction {
  static readonly type = '[Staffs] Staffs';

  constructor(public payload: any[]) {}
}